import * as React from "react";

const VerticalButton = ({
  btnName,
  btnType,
  type,
  modal,
  modalid,
  iconClass,
  iconStyle,
  btnStyle,
  onClick,
  disabled,
  loading,
  dataDismiss,
  id,
}) => {
  return (
    <button
      className={
        btnType === "primary"
          ? "hf-vertical-button hf-vertical-button-title mr-2"
          : "hf-vertical-button hf-btn-white mr-2"
      }
      data-bs-dismiss={dataDismiss}
      type={type}
      data-bs-toggle={modal}
      data-bs-target={modalid}
      style = {btnStyle}
      // data-bs-dismiss={dataDismiss}
      onClick={!loading ? onClick : () => {}}
      disabled={disabled}
      id={id}
    >
      {loading ? (
        <div
          className="spinner-border text-light"
          style={{ width: "18px", height: "18px" }}
          role="status"
        >
          <span className="sr-only">Loading...</span>
        </div>
      ) : (
        <>
          <i style={{ iconStyle }} className={iconClass} aria-hidden="true"></i>
          <p style={{ marginBottom : "0px"}}>{btnName}</p>
        </>
      )}
    </button>
  );
};

export default VerticalButton;
